import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { getStepDetails, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i5 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { BehaviorSubject } from 'rxjs';
import moment from 'moment';
import { map } from 'rxjs/internal/operators/map';
import * as CryptoJS from 'crypto-js';
import { pluck } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i6 from 'cache-country-list';
import * as i7 from 'reference-library';
import * as i8 from 'app-services-library';

class APILCASOCCode {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPositionDetails(companyId, petitionId) {
        return this.httpClient.get(`/petitionBuilder/job/positionDetails/company/${companyId}/petition/${petitionId}/`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getMajorGroupCodes(visaType, positionTitle) {
        var posTitle = positionTitle == null ? 'NULL' : this.toEncrypt(positionTitle);
        return this.httpClient.get(`/${visaType}/soc/majorGroup/position/title/${posTitle}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response.data;
            }
        }));
    }
    getSOCCodeList(majorGroup, searchQuery, type) {
        let apiUrl = type === '0' ? `/soc/search` : `/soc/search?full=true`;
        return this.httpClient.post(apiUrl, { 'majorGroup': majorGroup, 'searchQuery': searchQuery }).pipe(map((response) => {
            if (response && response.status === 200) {
                return response.data;
            }
        }));
    }
    getSOCCodeListWizard(majorGroup, searchQuery, type, otherPayloadValue = {}) {
        let apiUrl = type === '0' ? `/wizard/soc/search` : `/wizard/soc/search?full=true`;
        return this.httpClient.post(apiUrl, Object.assign({ 'majorGroup': majorGroup, 'searchQuery': searchQuery }, otherPayloadValue)).pipe(map((response) => {
            if (response && response.status === 200) {
                return response.data;
            }
        }));
    }
    getSOCCodeDetails(socCode, caseId) {
        return this.httpClient.get(`/petition/${caseId}/soc/${socCode}/detail`).pipe(map((response) => {
            if (response) {
                return response;
            }
        }));
    }
    getLcaCodesWizard(companyId) {
        return this.httpClient.get(`/wizard/${companyId}/lca/list/`).pipe(pluck('data'), map((codes) => {
            return codes;
        }));
    }
    getLcaById(id) {
        return this.httpClient.get(`/dashboard/petitioner/lca/${id}`).pipe(pluck('data'), map((codes) => {
            return codes;
        }));
    }
    postLcaSOCCodeSelection(visaType, caseType, caseId, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/occupationDetails`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getLcaSOCCodeSelection(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/occupationDetails`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
    getStates(countryCode) {
        return this.httpClient.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    getCounties(stateCode) {
        return this.httpClient.get(`/flagCounties?stateCode=${stateCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
}
APILCASOCCode.ɵfac = function APILCASOCCode_Factory(t) { return new (t || APILCASOCCode)(i0.ɵɵinject(i1.HttpClient)); };
APILCASOCCode.ɵprov = i0.ɵɵdefineInjectable({ token: APILCASOCCode, factory: APILCASOCCode.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APILCASOCCode, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

// import { CustomQuestionsGroupModule } from 'projects/custom-questions-group/src/public-api';
class BaseLcaSocCodeLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.flag = false;
        this.showThisContent$ = new BehaviorSubject(false);
        this.legal = false;
        this.isWizard = false;
        this.listStates = [];
        this.listCounty = [];
        this.lcaSocLoaded$ = new Subject();
        this.disabledControls = false;
        this.selectedCodeType = '0';
        this.listOfTasks = [];
        this.jobZone = null;
        this.wageList = [];
        this.selectedCode = null;
    }
    loadInit() {
        var _a;
        // Get Specific step details by passing step code
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                console.log('data', data);
                (_a = this.lcaSocCodeForm) === null || _a === void 0 ? void 0 : _a.reset();
                this.toggleControlsStatus();
                this.loadStep(this.stepDetails.companyId);
            });
        }
        else {
            this.loadStep(this.companyId);
        }
        if (this.isWizard) {
            this.apiService.getStates('USA').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.listStates = response;
                this.stateProvinceCode = this.listStates.find(val => val.stateProvinceCode == this.inputData.stateProvinceCode);
            });
        }
    }
    onLCARowExpand(event) {
        this.apiService.getSOCCodeDetails(event.data.onetSocCode, this.inputData.caseId).subscribe((response) => {
            if (response) {
                this.listOfTasks = response.data['tasks'] && response.data['tasks'].length > 0 ? response.data['tasks'] : [];
                this.jobZone = response.data['jobZone'] ? response.data['jobZone'] : null;
                this.wageList = response.data['wages'] && response.data['wages'].length > 0 ? response.data['wages'] : [];
            }
        });
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    afterViewInit() {
        this.lcaSocCodeForm.valueChanges.subscribe(() => {
            if (this.lcaSocCodeForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    loadStep(compId) {
        this.flag = true;
        this.apiService.getPositionDetails(compId, this.inputData.caseId).subscribe((response) => {
            if (response) {
                this.positionTitle = response.data['positionName'];
                this.apiService.getMajorGroupCodes(this.inputData.visatype, this.isWizard ? null : this.positionTitle).subscribe((groupCodeResponse) => {
                    this.majourGroupCodeList = groupCodeResponse ? groupCodeResponse : [];
                    // this.selectedMajorGroupCode = this.majourGroupCodeList[0].majorGroup;
                    this.getSelectedSOCCode();
                    // console.log(this.selectedMajorGroupCode, this.majourGroupCodeList + 'group', groupCodeResponse, this.positionTitle, this.selectedCodeType)
                    //this.handleMajorGroupCodeChange();
                });
            }
        });
    }
    getSelectedSOCCode() {
        this.apiService.getLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).subscribe((response) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            if (response) {
                this.occuapationDetails = response.data ? response.data : this.occuapationDetails;
                this.selectedMajorGroupCode = response.data['majorGroupCode'] ? response.data['majorGroupCode'] : this.selectedMajorGroupCode;
                this.defaultChange(this.selectedMajorGroupCode);
                // console.log(this.selectedMajorGroupCode, response.data['majorGroupCode'], this.occuapationDetails, this.listOfSocCode)
                this.defaultCode = response.data['specialityOccupation'];
                // this.selectedCode = response.data['specialityOccupation'] ? this.listOfSocCode.find(x => x.onetSocCode === response.data['specialityOccupation']) : null;
                this.selectedCodeType = response.data['socFullListReq'] === 0 ? '0' : '1';
                if (this.isWizard) {
                    this.lca = Object.assign(Object.assign({}, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.lca), { wageLevel: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.wage, location: (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.stateProvinceName, period: (((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.lca) === null || _e === void 0 ? void 0 : _e.employmentStartDate) && ((_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.lca) === null || _g === void 0 ? void 0 : _g.employmentEndDate)) ? `${moment(response.data.lca.employmentStartDate).utc().format('DD MMM YYYY')} to ${moment(response.data.lca.employmentEndDate).utc().format('DD MMM YYYY')}` : '--' });
                    this.lcaCodeId = (_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.lcaCodeId;
                    this.county = (_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.county;
                    this.positionTitle = (_l = (_k = response.data) === null || _k === void 0 ? void 0 : _k.lca) === null || _l === void 0 ? void 0 : _l.socTitle;
                    this.stateProvinceCode = (_m = response === null || response === void 0 ? void 0 : response.data) === null || _m === void 0 ? void 0 : _m.stateProvinceCode;
                    this.lcaSocLoaded$.next(true);
                    //this.handleStateChange();
                }
                this.handleCodeTypeChange();
            }
        });
    }
    manipulateMajorCode(data) {
        return data === null || data === void 0 ? void 0 : data.socCode.substring(2, 0).concat('-0000');
    }
    whenLcaChanged(data) {
        if (this.isWizard) {
            if (data && data.id) {
                this.getLcaById(data.id);
            }
            ///this.lca = {...response?.data?.lca, wageLevel: response?.data?.wage, location: response?.data?.stateProvinceName, period: (response?.data?.lca?.employmentStartDate && response?.data?.lca?.employmentEndDate) ? `${moment(response.data.lca.employmentStartDate).utc().format('DD MMM YYYY')} to ${moment(response.data.lca.employmentEndDate).utc().format('DD MMM YYYY')}` : '--' };
            //this.lcaCodeId = data?.lcaCodeId;
        }
    }
    getLcaById(id) {
        this.apiService.getLcaById(id).subscribe((val) => {
            var _a, _b, _c, _d, _e;
            if (this.isWizard) {
                this.county = (_b = (_a = val === null || val === void 0 ? void 0 : val.placeList[0]) === null || _a === void 0 ? void 0 : _a.addressDTO) === null || _b === void 0 ? void 0 : _b.county;
                this.positionTitle = (_c = val === null || val === void 0 ? void 0 : val.lcaApplication) === null || _c === void 0 ? void 0 : _c.socTitle;
                this.selectedMajorGroupCode = this.manipulateMajorCode(val === null || val === void 0 ? void 0 : val.lcaApplication);
                this.stateProvinceCode = (_e = (_d = val === null || val === void 0 ? void 0 : val.placeList[0]) === null || _d === void 0 ? void 0 : _d.addressDTO) === null || _e === void 0 ? void 0 : _e.stateProvinceCode;
                this.handleStateChange();
            }
        });
    }
    defaultChange(evt) {
        this.param1 = evt;
        // console.log(this.param1)
        //this.handleCodeTypeChange();
    }
    handleMajorGroupCodeChange() {
        this.handleCodeTypeChange();
    }
    handleCodeTypeChange() {
        // console.log(this.selectedMajorGroupCode, this.positionTitle, this.selectedCodeType, this.param1, this.selectedCode);
        const otherPayloadValue = { stateProvinceCode: this.stateProvinceCode, county: this.county };
        if (this.selectedMajorGroupCode == '23-0000') {
            this.showThisContent$.next(true);
            // this.selectedCodeType = '1';
            const req = this.isWizard ? ((otherPayloadValue.stateProvinceCode && otherPayloadValue.county) ? this.apiService.getSOCCodeListWizard(this.selectedMajorGroupCode, this.positionTitle, this.selectedCodeType, otherPayloadValue) : null) : this.apiService.getSOCCodeList(this.selectedMajorGroupCode, this.positionTitle, this.selectedCodeType);
            req === null || req === void 0 ? void 0 : req.subscribe((listOfCodesResponse) => {
                var _a;
                this.listOfSocCode = listOfCodesResponse;
                // console.log(this.listOfSocCode, 'listOfSocCode')
                if ((_a = this.listOfSocCode) === null || _a === void 0 ? void 0 : _a.length) {
                    this.listOfSocCode.forEach(x => {
                        x['5.0'] = x.educationList.find(y => y.educationLevel === '5.0') ? x.educationList.find(y => y.educationLevel === '5.0')['percentage'] : 0;
                        x['6.0'] = x.educationList.find(y => y.educationLevel === '6.0') ? x.educationList.find(y => y.educationLevel === '6.0')['percentage'] : 0;
                        x['8.0'] = x.educationList.find(y => y.educationLevel === '8.0') ? x.educationList.find(y => y.educationLevel === '8.0')['percentage'] : 0;
                    });
                    this.selectedCode = this.listOfSocCode[0];
                    this.recommendedCode = this.listOfSocCode[0];
                    // console.log(this.selectedCode)
                    this.showThisContent$.next(false);
                }
                // this.getSelectedSOCCode();
            });
        }
        else if (this.selectedMajorGroupCode) {
            this.showThisContent$.next(false);
            this.selectedCodeType = '0';
            const req = this.isWizard ? ((otherPayloadValue.stateProvinceCode && otherPayloadValue.county) ? this.apiService.getSOCCodeListWizard(this.selectedMajorGroupCode, this.positionTitle, this.selectedCodeType, otherPayloadValue) : null) : this.apiService.getSOCCodeList(this.selectedMajorGroupCode, this.positionTitle, this.selectedCodeType);
            req === null || req === void 0 ? void 0 : req.subscribe((listOfCodesResponse) => {
                var _a, _b;
                this.listOfSocCode = listOfCodesResponse;
                // console.log(this.listOfSocCode)
                if ((_a = this.listOfSocCode) === null || _a === void 0 ? void 0 : _a.length) {
                    this.listOfSocCode.forEach(x => {
                        var _a;
                        x['5.0'] = x.educationList.find(y => y.educationLevel === '5.0') ? x.educationList.find(y => y.educationLevel === '5.0')['percentage'] : 0;
                        x['6.0'] = x.educationList.find(y => y.educationLevel === '6.0') ? x.educationList.find(y => y.educationLevel === '6.0')['percentage'] : 0;
                        x['8.0'] = x.educationList.find(y => y.educationLevel === '8.0') ? x.educationList.find(y => y.educationLevel === '8.0')['percentage'] : 0;
                        if (this.isWizard) {
                            x['isSelected'] = (((_a = this.occuapationDetails) === null || _a === void 0 ? void 0 : _a.specialityOccupation) === x.onetSocCode && x['stateProvinceCode'] === this.stateProvinceCode && this.county === x['county']);
                            x['codeStateCount'] = `${x['onetSocCode']}-${x['stateProvinceCode']}-${x['county']}`;
                        }
                    });
                    this.selectedCode = !this.isWizard ? this.listOfSocCode[0] : (_b = this.listOfSocCode) === null || _b === void 0 ? void 0 : _b.find((x) => x['isSelected']);
                    this.recommendedCode = Object.assign({}, this.listOfSocCode[0]);
                    if (this.defaultCode) {
                        const foundIndex = !this.isWizard ? this.listOfSocCode.findIndex((x) => x.onetSocCode === this.defaultCode) : this.listOfSocCode.findIndex((x) => x['isSelected']);
                        this.selectedCode = this.listOfSocCode[foundIndex];
                        this.listOfSocCode.splice(foundIndex, 1);
                        this.listOfSocCode.unshift(this.selectedCode);
                    }
                }
            });
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCancel() {
        this.loadStep(this.stepDetails.companyId);
    }
    postSelectedSOCCode(item, data) {
        var _a, _b, _c, _d;
        const payload = {};
        payload.id = null;
        //payload.lca = null;
        payload.lcaCodeId = this.lcaCodeId;
        payload.majorGroupCode = this.selectedMajorGroupCode;
        payload.occupationDescription = null;
        payload.socFullListReq = this.selectedCodeType === '0' ? 0 : 1;
        if (this.isWizard) {
            payload.stateProvinceCode = ((_a = this.selectedCode) === null || _a === void 0 ? void 0 : _a.stateProvinceCode) || this.stateProvinceCode;
            payload.county = ((_b = this.selectedCode) === null || _b === void 0 ? void 0 : _b.county) || this.county;
            payload.wage = ((_c = this.selectedCode) === null || _c === void 0 ? void 0 : _c.wage) || null;
        }
        switch (item) {
            case 1:
                payload.specialityOccupation = (_d = this.selectedCode) === null || _d === void 0 ? void 0 : _d.onetSocCode;
                break;
            case 2:
                payload.specialityOccupation = data;
                break;
            default:
                break;
        }
        this.apiService.postLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, payload).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.loadInit();
                // this.lcaSocCodeForm.reset(this.lcaSocCodeForm.value);
                // this.loadStep();
            }
        });
    }
    handleStateChange() {
        this.apiService.getCounties(this.stateProvinceCode)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((county) => {
            var _a, _b, _c;
            this.listCounty = county;
            if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.countryCode) {
                this.county = (_b = this.listCounty) === null || _b === void 0 ? void 0 : _b.find(val => (val === null || val === void 0 ? void 0 : val.countryCode) === this.inputData.countryCode);
            }
            if (((_c = this.occuapationDetails) === null || _c === void 0 ? void 0 : _c.county) || this.county) {
                this.handleCountyChange();
            }
        });
    }
    handleCountyChange() {
        this.handleCodeTypeChange();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.lcaSocLoaded$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseLcaSocCodeLibraryService.ɵfac = function BaseLcaSocCodeLibraryService_Factory(t) { return new (t || BaseLcaSocCodeLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APILCASOCCode), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DirtyFormGuard), i0.ɵɵinject(i6.CacheCountryListService), i0.ɵɵinject(i7.ReferenceLibraryService), i0.ɵɵinject(i8.AppServicesLibraryService)); };
BaseLcaSocCodeLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseLcaSocCodeLibraryService, factory: BaseLcaSocCodeLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseLcaSocCodeLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APILCASOCCode }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.CacheCountryListService }, { type: i7.ReferenceLibraryService }, { type: i8.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-lca-soc-code-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APILCASOCCode, BaseLcaSocCodeLibraryService };
//# sourceMappingURL=base-lca-soc-code-library.js.map
